import { HOME_ROUTE, LOGIN_ROUTE, REGISTRATION_ROUTE } from "@/utils/const";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const OLD_CABINET_DOMAIN = "https://i.akvastar.ru";
const REDIRECT_HOSTS = ["i2.akvastar.ru", "i3.akvastar.ru"];

const AuthRoute = () => {
  const { isAuth } = useAuth();
  const location = useLocation();

  // Redirect login/registration pages to old domain (from i2/i3.akvastar.ru)
  if (
    REDIRECT_HOSTS.includes(window.location.hostname) &&
    (location.pathname === LOGIN_ROUTE || location.pathname === REGISTRATION_ROUTE)
  ) {
    window.location.href = `${OLD_CABINET_DOMAIN}${location.pathname}`;
    return null;
  }

  if (isAuth) {
    return <Navigate to={HOME_ROUTE} replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
